export const messages = {
  en: {
    ownerApplyInvoice: {
      title: 'Invoice Application',
      invoiceTitle: 'Invoice Title',
      taxpayerId: 'Taxpayer ID',
      invoiceType: 'Invoice Type',
      addressPhone: 'Address & Phone',
      owner: 'Owner',
      content: 'Content',
      personal: 'Personal',
      enterprise: 'Enterprise',
      paidFees: 'Paid Fees',
      accountDeposit: 'Account Deposit',
      feeName: 'Fee Item',
      payer: 'Payer',
      receivablePaid: 'Receivable/Paid',
      paymentMethod: 'Payment Method',
      paymentPeriod: 'Payment Period',
      paymentTime: 'Payment Time',
      cashier: 'Cashier',
      status: 'Status',
      remark: 'Remark',
      accountName: 'Account Name',
      accountType: 'Account Type',
      depositAmount: 'Deposit Amount',
      depositMethod: 'Deposit Method',
      totalAmount: 'Total Amount',
      depositTime: 'Deposit Time',
      back: 'Back',
      select: 'Select',
      submit: 'Submit',
      required: 'Required',
      chooseInvoiceTitle: 'Please select invoice title',
      chooseTaxId: 'Please select taxpayer ID',
      chooseInvoiceType: 'Please select invoice type',
      chooseAddressPhone: 'Please enter address and phone',
      chooseContent: 'Please select content',
      noFeeSelected: 'No paid fees selected',
      noDepositSelected: 'No account deposit selected'
    },
    searchOwnerInvoice: {
      title: 'Select Owner',
      ownerName: 'Owner Name',
      invoiceType: 'Invoice Type',
      invoiceTitle: 'Invoice Title',
      taxpayerId: 'Taxpayer ID',
      addressPhone: 'Address & Phone',
      operation: 'Operation',
      search: 'Search',
      placeholderRoom: 'Enter room number (building-unit-room)',
      placeholderOwner: 'Enter owner name',
      select: 'Select',
      personal: 'Personal',
      company: 'Company'
    }
  },
  zh: {
    ownerApplyInvoice: {
      title: '发票申请',
      invoiceTitle: '发票抬头',
      taxpayerId: '纳税人识别号',
      invoiceType: '发票类型',
      addressPhone: '地址、电话',
      owner: '业主',
      content: '开票内容',
      personal: '个人',
      enterprise: '企业',
      paidFees: '已缴费费用',
      accountDeposit: '账户预存',
      feeName: '费用项',
      payer: '收费对象',
      receivablePaid: '应收/实收',
      paymentMethod: '缴费方式',
      paymentPeriod: '缴费起始段',
      paymentTime: '缴费时间',
      cashier: '收银员',
      status: '状态',
      remark: '备注',
      accountName: '账户名称',
      accountType: '账户类型',
      depositAmount: '预存金额(元)',
      depositMethod: '预存方式',
      totalAmount: '总金额(元)',
      depositTime: '预存时间',
      back: '返回',
      select: '选择',
      submit: '提交',
      required: '必填',
      chooseInvoiceTitle: '请选择发票抬头',
      chooseTaxId: '请选择纳税人识别号',
      chooseInvoiceType: '请选择发票类型',
      chooseAddressPhone: '请输入地址、电话',
      chooseContent: '请选择开票内容',
      noFeeSelected: '未选择已缴费费用',
      noDepositSelected: '未选择账户预存'
    },
    searchOwnerInvoice: {
      title: '选择发票抬头',
      ownerName: '业主名称',
      invoiceType: '发票类型',
      invoiceTitle: '发票名头',
      taxpayerId: '纳税人识别号',
      addressPhone: '地址、电话',
      operation: '操作',
      search: '查询',
      placeholderRoom: '输入房屋编号楼栋-单元-房屋',
      placeholderOwner: '输入业主名称',
      select: '选择',
      personal: '个人',
      company: '公司'
    }
  }
}